import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../../components/Configurer";
import ProfileImage from "../../components/partials/ProfileImage";
import ItemModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
import { checkPermission, checkTextTranslation, checkTranslation, getObject, getPermissionObject, imageAddress, pathMaker, setObject, translate } from "../../utils/useful";
import DataGrid from "../../components/DataGrid";
import Pagination from "../../components/Pagination";
import OptionsListModal from "../../modals/OptionsListModal";
import RemoveConfirmationModal from "../../modals/RemoveConfirmationModal";
import FormViewer from "../../components/FormViewer";
import { AccountingAppletPermissions } from "../../variables/PermissionsData";
import LoaderButton from "../../components/LoaderButton";
import { withRouter } from "react-router";
import SearchUsersModal from "../../modals/SearchUsersModal";
import AddPermissionModal from "../../modals/AddPermissionModal";
import SearchGroupsModal from "../../modals/SearchGroupsModal";
import TextAreaInput from "../../components/inputs/TextAreaInput";


class AdminPermission extends React.Component {


    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })

        // console.log("remove")
    }

    state = {
        data: [],
        actions: {
            add: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: this.openEditModal },
            edit: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        currentPage: 0,
        limit: 10,
        currentTab: 'users',
        sections: {},
        permission: {
            description: '',
            users: [],
            groups: [],
            permissions: {},
        }

    }


    componentDidMount() {
        setTimeout(() => {
            this.init()
        }, 100);
    }

    componentDidUpdate(prevProps) {
        // console.log("componentDidUpdate")
        if (this.props.page && this.props.page !== prevProps.page) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
        // setTimeout(() => {
        //     this.setState({ indeterminate: true })
        // }, 400);
    }

    setData = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }


    init() {
        // console.log("INIT",this.props.page)
        if (this.props.page) {
            // console.log(this.props.validSections)
            let validSections = this.props.validSections
            let sections = {}
for (let i = 0; i < validSections.length; i++) {
    const validSection = validSections[i];
    sections[validSection] = AccountingAppletPermissions.sections[validSection]
}


            this.setState({ sections: sections })
            this.setState({ data: [] }, () => {
                this.fetchData(true)
            })
        }
    }

    fetchData = (getCount) => {
        // let windowData = this.props.windowData
        // let search = this.props.location.search;
        // let params = new URLSearchParams(search);
        let id = this.props.windowData?.params?.id

        // console.log(search, params, id)
        // console.log(this.props.variables?.permissionRoot)

        if (id && !checkPermission(this.props.variables?.permissionRoot + '.edit')) {
            this.props.informParent('permissionDenied')
            // console.log("PTP1")
            return
        }

        if (!id && !checkPermission(this.props.variables?.permissionRoot + '.create')) {
            this.props.informParent('permissionDenied')

            // console.log(this.props.variables?.permissionRoot+'.create')
            // console.log(id)
            // console.log("PTP2")

            return
        }


        if (id && id !== '') {
            this.setState({ isLoadingData: true })

            let body = { _id: id }
            if (this.props.applet) {
                body.applet = this.props.applet?._id
            }

            // return
            HttpServices.request(this.props.page?.fetchUrl, body, (fetchResult, fetchError) => {
                this.setState({ isLoadingData: false })
                // console.log(fetchResult)
                // console.log(fetchError)

                if (fetchError) {
                    this.props.informParent('notFound')
                    this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.loadDataFailed'), description: checkTranslation(fetchError.message) })
                    return
                }
                // console.log(fetchResult)
                if (fetchResult.info) {
                    this.setState({ permission: fetchResult.info })
                } else {
                    this.props.informParent('notFound')
                }


            })
        }
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.removeFailed'), description: checkTranslation(fetchError.message) })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}info.removedSuccesfully'), description: checkTranslation('{{lang}}info.dataRemovedSuccessfully') })


        })

    }



    submitClicked = () => {
        this.setState({ isLoadingSubmit: true })

        let permission = JSON.parse(JSON.stringify(this.state.permission))

        if (!permission.users || Object.values(permission.users).length == 0) {
            this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.usersNotSelected'), description: checkTranslation("{{lang}}errors.usersNotSelected") })
            return
        }
        if (!permission.permissions || Object.values(permission.permissions).length == 0) {
            this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.permissionsNotSelected'), description: checkTranslation("{{lang}}errors.permissionsNotSelected") })
            return
        }

        permission.users.forEach((user, index) => {
            if (typeof user == 'object') {
                permission.users[index] = user._id
            }
        });
        // permission.groups.forEach((user, index) => {
        //     if (typeof user == 'object') {
        //         permission.groups[index] = user._id
        //     }
        // });

        let body = this.props.page.postBody
        if (!body) {
            body = {}
        }
        body = permission

        if (this.props.applet) {
            body.applet = this.props.applet?._id ?? this.props.applet
        }


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    if (typeof body[key] == 'object') {
                        body[key] = body[key]._id
                    }
                }
            }
        }

        // console.log(this.props.page.addUrl, body)
        // return

        HttpServices.request(this.props.page.addUrl, body, (fetchResult, fetchError) => {

            // console.log("******")
            // HttpServices.request(this.props.page.addUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingSubmit: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.postFailed'), description: checkTranslation(fetchError.message) })
                return
            }

            this.cancelClicked()
            // let data = this.state.data

            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}info.sumbitSuccesfully'), description: checkTranslation('{{lang}}info.dataPostedSuccessfully') })


        })

    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.removeFailed'), description: checkTranslation(fetchError.message) })
                return
            }
            let data = this.state.data

            data.forEach((element, index) => {
                if (element._id == id) {
                    data.splice(index, 1)
                }
            });

            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}info.removedSuccesfully'), description: checkTranslation('{{lang}}info.dataRemovedSuccessfully') })


        })

    }


    fetchDisconnect = () => {
        this.fetchStatus(-1)
    }

    fetchConnect = () => {
        this.fetchStatus(1)
    }



    fetchStatus = (newStatus) => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request('changeThingStatus', { "id": id, status: newStatus }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            // console.log(this.state.currentIndex)
            let data = this.state.data

            data.forEach((element, index) => {
                if (element._id == id) {
                    data[index].status = newStatus
                }
            });

            this.setState({ data })
            // this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.actionSuccesfully', description: '{{lang}}info.dataActionSuccessfully' })

        })
    }

    changePage = (page) => {
        this.props.changePage(page)
        // console.log("changePage")
    }

    fullAccessedClicked = (section, permission) => {
        // console.log("fullAccessedClicked")
        let permissions = this.state.permission.permissions

        let allowed = this.getPermission(section.key + '.' + permission.key)
        let sectionPermissionStatus = getPermissionObject(permissions, section.key)


        // console.log(sectionPermissionStatus)
        // console.log(allowed, section.key + '.' + permission.key, permissions)

        if (allowed) {

            if (sectionPermissionStatus.value == '*') {

                setObject(permissions, section.key, {})

                Object.values(section.permissions).forEach(pheader => {
                    if (pheader.key != permission.key && !pheader.reverse) {
                        setObject(permissions, section.key + '.' + pheader.key, '*')
                    }
                })

            }

            setObject(permissions, section.key + '.' + permission.key, null)

        } else {
            setObject(permissions, section.key + '.' + permission.key, '*')

            // if (!permissions) {
            //     permissions = {}
            // }
            // if (!permissions[section.key]) {
            //     permissions[section.key] = {}
            // }

            // permissions[section.key][permission.key] = '*'
        }


        let thisSectionPermissions = permissions[section.key]
        let isFullAccess = true





        if (thisSectionPermissions && typeof thisSectionPermissions == 'object') {
            Object.values(section.permissions).forEach(sectionPermission => {

                if (thisSectionPermissions[sectionPermission.key] != '*' && !sectionPermission.reverse) {
                    isFullAccess = false
                }
            })
        }


        if (isFullAccess) {
            setObject(permissions, section.key, '*')

        }

        // console.log(permissions)
        let fullpermission = this.state.permission
        fullpermission.permissions = permissions
        this.setState({ permission: fullpermission })
        // console.log(permissions)

        // permission.levels.forEach(level => {
        //     permissions[section][permissions] = true
        // });

    }


    changeAccess = (section, permission, header) => {
        // console.log("changeAccess", section, permission, header)
        let permissionKey = section.key + '.' + permission.key
        let key = permissionKey + '.' + header.key

        let permissions = this.state.permission.permissions
        let permissionStatus = getPermissionObject(permissions, key, null, header.reverse)
        let sectionPermissionStatus = getPermissionObject(permissions, section.key)
        let parentPermissionStatus

        if (permissionStatus.parentKey) {
            parentPermissionStatus = getPermissionObject(permissions, permissionKey)
        }

        // console.log("permissionKey", permissionKey)

        // console.log("parentPermissionStatus", parentPermissionStatus)

        // console.log("permissionStatus", permissionStatus)
        // console.log("permissions", JSON.parse(JSON.stringify(permissions)))


        if (permissionStatus.allowed) {

            if (permissionStatus.parentLevel) {
                setObject(permissions, permissionStatus.parentKey, null)
                Object.values(permission.headers).forEach(pheader => {

                    if (pheader.key != header.key && pheader.dependancy != header.key && !pheader.reverse) {
                        // console.log("AA",pheader)
                        setObject(permissions, permissionKey + '.' + pheader.key, '*')
                    }
                })

                if (sectionPermissionStatus.value == '*') {
                    Object.values(section.permissions).forEach(pheader => {
                        if (pheader.key != permission.key && !pheader.reverse) {
                            setObject(permissions, section.key + '.' + pheader.key, '*')
                        }
                    })
                }


            } else {
                // setObject(permissions, key, null)
                Object.values(permission.headers).forEach(pheader => {
                    if (pheader.key == header.key || pheader.dependancy == header.key) {
                        setObject(permissions, permissionKey + '.' + pheader.key, null)
                    }
                });
            }





        }

        // console.log("permissions", permissions)


        if (!permissionStatus.allowed) {

            if (header.reverse) {

                // console.log("sectionPermissionStatus.value", sectionPermissionStatus.value)


                if (permissionStatus?.value == '*' && permissionStatus.parentKey == '') {

                    setObject(permissions, section.key, null)

                    Object.values(section.permissions).forEach(pheader => {
                        // if (pheader.key != permission.key && !pheader.reverse) {
                        setObject(permissions, section.key + '.' + pheader.key, '*')
                        // }
                    })
                }



                // console.log("parentPermissionStatus", parentPermissionStatus)
                // console.log("HEREE", permissionKey)
                // if (permissionStatus.parentKey) {
                parentPermissionStatus = getPermissionObject(permissions, permissionKey)
                // }

                if (parentPermissionStatus?.value == '*') {

                    setObject(permissions, permissionKey, null)


                    Object.values(permission.headers).forEach(pheader => {

                        // console.log("AA", pheader.key, permission.key)

                        // if (pheader.key == header.key || pheader.dependancy == header.key) {
                        setObject(permissions, permissionKey + '.' + pheader.key, '*')
                        // }
                    })


                }

            }
            // setObject(permissions, key, '*')
            Object.values(permission.headers).forEach(pheader => {
                if (pheader.key == header.key || header.dependancy == pheader.key) {
                    // console.log("pheader", pheader)

                    setObject(permissions, permissionKey + '.' + pheader.key, '*')
                }
            })

        }

        // console.log("permissions2", JSON.parse(JSON.stringify(permissions)))


        // Object.values(permission.headers).forEach(pheader => {
        let permissionValue = getPermissionObject(permissions, permissionKey).value
        if (permissionValue != '*' && permissionValue != null && typeof permissionValue == 'object') {
            let keys = Object.keys(permissionValue)
            let keysCount = 0
            keys.forEach(element => {
                if (!element.startsWith('*')) {
                    keysCount++
                }
            })
            // console.log(keysCount)
            // console.log(permissionKey)

            // if (keysCount == Object.keys(permission.headers).length) {
            //     setObject(permissions, permissionKey + '.' + '**fullAccess', '*')
            // } else if (keysCount > 0) {
            //     setObject(permissions, permissionKey + '.' + '**fullAccess', '-')
            // } else {
            //     setObject(permissions, permissionKey + '.' + '**fullAccess', null)
            // }
        }

        // });

        let thisSectionPermissions = permissions[section.key]
        let isFullAccess = true
        let isFullHeaderAccess = true


        Object.values(permission.headers).forEach(pheader => {

            let key = permissionKey + '.' + pheader.key
            let myPermissionStatus = getPermissionObject(permissions, key)
            // console.log(myPermissionStatus)
            if (myPermissionStatus.value != '*' && !pheader.reverse) {
                isFullHeaderAccess = false
            } else if (myPermissionStatus.value == '*' && pheader.reverse) {
                isFullHeaderAccess = false
                // console.log("HERE",myPermissionStatus.value,pheader.reverse)
            }

        })


        // console.log("isFullHeaderAccess",isFullHeaderAccess)

        if (isFullHeaderAccess) {
            setObject(permissions, permissionKey, '*')
        }


        if (thisSectionPermissions && typeof thisSectionPermissions == 'object') {
            Object.values(section.permissions).forEach(sectionPermission => {

                if (thisSectionPermissions[sectionPermission.key] != '*') {
                    isFullAccess = false
                }
            })
        }


        if (isFullAccess) {
            setObject(permissions, section.key, '*')

        }

        // console.log("permissions", permissions)

        let fullpermission = this.state.permission
        fullpermission.permissions = permissions
        this.setState({ permission: fullpermission })

    }


    getPermission(key, reverse) {
        // console.log(key)
        let permissions = this.state.permission.permissions

        let allowed = getPermissionObject(permissions, key, null, reverse).allowed
        // console.log(allowed)
        return allowed
    }

    // templatePermission(key) {
    //     let permission = this.state.permission
    //     if (key == 'admin') {
    //         console.log('tp-admin', key)
    //         permission.permissions = {
    //             admin: {
    //                 adminLogs: '*',
    //                 mydocuments: '*',
    //                 myRecords: '*',
    //                 documentsorinformation: '*',
    //                 documentsorconsultation: '*',
    //                 senttome: '*',
    //                 documentcreationrequests: '*',
    //                 requestsfordeletionorediting: '*',
    //                 requesttocreateadocumentoperation: '*',
    //                 requesttocreatearecordoperation: '*',
    //                 requesttoeditordeleteoperation: '*',
    //                 documents: '*',
    //                 recordssearch: '*',
    //                 documentsearch: '*',
    //                 searchrecords: '*',
    //                 responsibilities: '*',
    //                 documenttype: '*',
    //                 recordsgroup: '*',
    //                 documentgroup: '*',
    //                 workflowpattern: '*',
    //                 distributionlist: '*',
    //                 processes: '*',
    //                 users: '*',
    //                 jobs: '*',
    //                 chart: '*',
    //                 permissions: '*'
    //             }
    //         }

    //     } else if (key == 'editor') {
    //         permission.permissions = {
    //             admin: {
    //                 mydocuments: '*',
    //                 myRecords: '*',
    //                 documentsorinformation: '*',
    //                 documentsorconsultation: '*',
    //                 senttome: '*',
    //                 documentcreationrequests: '*',
    //                 requestsfordeletionorediting: '*',
    //                 requesttocreateadocumentoperation: '*',
    //                 requesttocreatearecordoperation: '*',
    //                 requesttoeditordeleteoperation: '*',
    //                 documents: '*',
    //                 recordssearch: '*',
    //                 documentsearch: '*',
    //                 searchrecords: '*'
    //             }
    //         }
    //     } else if (key == 'user') {
    //         permission.permissions = {
    //             admin: {
    //                 mydocuments: '*',
    //                 myRecords: '*',
    //                 documentsorinformation: '*',
    //                 documentsorconsultation: '*',
    //                 senttome: '*',
    //                 documentcreationrequests: '*',
    //                 requestsfordeletionorediting: '*',
    //                 requesttocreateadocumentoperation: '*',
    //                 requesttocreatearecordoperation: '*',
    //                 requesttoeditordeleteoperation: '*',
    //             }
    //         }
    //     }
    //     this.setState({ permission })
    // }

    getFullAccessPermission(key) {
        let permissions = this.state.permission.permissions
        // console.log(permissions)
        let permission = getPermissionObject(permissions, key)
        let value = permission?.value
        // console.log(key, value)
        // if (value != '*') {
        //     value = getPermissionObject(permissions, key).value
        // }
        // console.log(value)
        if (value == null) {
            value = false
        } else {
            if (value == '*') {
                value = '*'
            } else {
                let hasLimitedPermission = false
                let hasFullPermission = true
                // console.log(getPermissionObject(permissions, key))
                let tempSections = AccountingAppletPermissions.sections?.[permission.parentKey]?.permissions?.[permission.key]?.headers
                for (const [mkey, mvalue] of Object.entries(tempSections)) {
                    // console.log("tempSections", tempSections)

                    if (value[mkey] != '*' || (value[mkey] == '*' && tempSections[mkey].reverse)) {
                        hasFullPermission = false
                    } else {
                        hasLimitedPermission = true
                    }
                }

                if (hasFullPermission) {
                    value = true
                } else {
                    if (hasLimitedPermission) {
                        value = '-'
                    } else {
                        value = false
                    }
                }
                // let tempSection = getObject(AccountingAppletPermissions.sections, key)
                // console.log(tempSection)
            }
        }
        // console.log(value)
        return value
    }


    cancelClicked = () => {
        // let search = this.props.location.search;
        // let params = new URLSearchParams(search);
        let ref = this.props.windowData?.params?.ref

        // console.log(pathMaker(ref))
        // return
        window.history.pushState({}, '', pathMaker(ref));

        // if (ref && ref !== '') {
        //     this.props.history.push(ref)
        // } else {
        //     this.props.history.goBack()
        // }

    }

    permissionTypeSelected = (type) => {
        if (type == 'users') {
            this.searchUsersModal.showModal()
        } else {
            this.searchGroupsModal.showModal()
        }
    }

    openUsersSearch = () => {
        this.searchUsersModal.showModal()

        // this.addPermissionModal.modal.showModal()
    }

    onNewUsersSelected = (users, type, cb) => {
        let permission = this.state.permission

        let current = {}
        permission[type].forEach(one => {
            current[one._id] = one
        });

        let full = { ...current, ...users }

        permission[type] = Object.values(full)

        this.setState({ permission })
        cb()
        // console.log(users)
    }


    removeUser = (id, type) => {
        let permission = this.state.permission
        let removeIndex = null

        permission[type].forEach((element, index) => {
            if (element._id == id) {
                removeIndex = index
            }
        });

        if (removeIndex != null) {
            permission[type].splice(removeIndex, 1)
        }

        this.setState({ permission })
    }

    changeDescription = (key, value) => {

        let permisison = this.state.permission
        permisison.description = value
        this.setState({ permisison })
    }

    render() {
        // console.log( this.props.page?.actions)

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        variables.changePage = this.changePage

        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation('permission'), button: { goBack: true } }}
                title={checkTextTranslation('permission')}
                description={checkTextTranslation("permission manager")}
                className=""
            >

                <div className=" " style={{ padding: '10px 3% 20px 3%', borderBottom: '1px solid #eee' }}>
                    <div className="row m-0" >
                        <div className="col-12 px-0 " >
                            <div className="p-0" style={{ borderRadius: 0 }}>

                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                    <div className="flexc mt-2">
                                        <img src="/images/password.svg" height="40px" />
                                        <div>
                                            <p className="text-big font-bold m-0 " style={{ color: '#0d172a' }}>{this.state.permission?._id ? translate("Edit Permission") : translate("New Permission")}</p>
                                            <p className="text-small m-0" style={{ color: '#89a' }} >{this.state.permission?._id ? translate("edit permisison for users / groups") : translate("New permisison for users / groups")}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className=" " style={{ padding: '10px 3% 10px 3%' }}>
                    <div className="row m-0">

                        <div className="col-12 mb-5  w-100 p-2" >

                            <div className="mb-4 pb-4" style={{ width: '100%', maxWidth: 400, borderBottom: '1px solid #eee' }}>
                                <div className="flexcb mb-2">
                                    <p className="required ">{translate("Permission for")}</p>
                                    <button onClick={() => this.openUsersSearch()} style={{ backgroundColor: '#2163ba', color: '#fff', borderRadius: '20px', padding: '5px 12px' }}>+ {translate("Add New")}</button>
                                </div>

                                <div className="flexc flex-column w-100" >
                                    {(!this.state.permission || ((!this.state.permission.users || this.state.permission.users.length == 0))) && (
                                        <div className="w-100">
                                            <p className="text-smaller mt-1 text-center" style={{ color: '#789' }}>{translate("Nothing Selected")}</p>
                                        </div>
                                    )}


                                    {/* {this.state.permission?.groups && this.state.permission.groups.map((prop, index) => {

                                        return (
                                            <div key={prop._id} className="w-100 mb-1" style={{ backgroundColor: '#f2f6f8', padding: '8px 10px', borderRadius: 4 }}>
                                                <div className="flexc">
                                                    <button onClick={() => this.removeUser(prop._id, 'groups')} className="flexcc text-bold mrd-2" style={{ backgroundColor: '#789', borderRadius: 20, height: 15, width: 15, fontSize: 10, color: '#fff' }}><p>X</p></button>
                                                    <div className='flexcb w-100'>
                                                        <p className="text-small text-bold" style={{ color: 'rgb(33, 37, 41)' }}>{prop.name}</p>
                                                        <p className="text-smallest text-uppercase text-bold " style={{ color: '#789' }}>{translate("group")}</p>

                                                    </div>
                                                </div>
                                            </div>
                                        )

                                    })} */}

                                    {this.state.permission?.users && this.state.permission.users.map((prop, index) => {

                                        return (
                                            <div key={prop._id} className="w-100 mb-1" style={{ backgroundColor: '#f2f6f8', padding: '8px 10px', borderRadius: 4 }}>

                                                <div className="flexcb">
                                                    <button onClick={() => this.removeUser(prop._id, 'users')} className="flexcc text-bold mrd-2" style={{ backgroundColor: '#789', borderRadius: 20, height: 20, width: 20, fontSize: 10, color: '#fff' }}>
                                                        <img src="/images/close.svg" className="" style={{ width: 10, height: 10, filter: 'invert(100%)' }} />
                                                    </button>

                                                    <div className='flexc'>
                                                        <div>
                                                            <p className="text-small text-bold" style={{ color: 'rgb(33, 37, 41)' }}>{prop.name}</p>
                                                            <p className="text-smallest text-uppercase text-bold " style={{ color: '#789' }}>@{prop.username}</p>

                                                        </div>
                                                        <img className="mx-1" src={imageAddress(prop.image)} width="35px" style={{ borderRadius: 50, height: 35, objectFit: 'cover' }} />
                                                    </div>
                                                </div>
                                            </div>
                                        )

                                    })}
                                </div>

                                <div className="mt-4 modern-input" style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: 7 }}>

                                    <TextAreaInput changeValue={this.changeDescription} data={this.state.permission?.description} header={{ key: 'description', information: { rows: 3, placeholder: '{{lang}}description' } }} />
                                </div>
                            </div>

                            {/* <div className="mt-2" style={{ width: '100%', maxWidth: 400 }}>
                                <FormViewer ref={el => this.form = el} headers={this.props.page?.headers} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} variables={variables} />
                            </div> */}

                            {/* <div className="w-100 px-4 py-3" style={{ backgroundColor: '#e5f6ff', borderRadius: 8, color: '#212529' }}>
                                <p className="text-semibig text-bold">Inheret Permissions from</p>
                                <p className="text-small">Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum, obcaecati. Porro laboriosam architecto animi cum at tempora corporis sit eos facere asperiores aliquid quod, dolore tempore perferendis deleniti aliquam hic?</p>
                            </div> */}


                            <div className="mt-3">
                                {/* <div className="flexc my-3 pb-3">
                                    <div onClick={() => this.templatePermission('admin')} className="px-3" style={{ color: '#222', outline: 'none', background: 'white', borderLeft: '2px solid #2266c1' }}>{translate("Admin")}</div>
                                    <div onClick={() => this.templatePermission('editor')} className="px-3" style={{ color: '#222', outline: 'none', background: 'white', borderLeft: '2px solid #2266c1' }}>{translate("Editor")}</div>
                                    <div onClick={() => this.templatePermission('user')} className="px-3" style={{ color: '#222', outline: 'none', background: 'white' }}>{translate("User")}</div>
                                </div> */}

                                {Object.values(this.state.sections).map((section, index) => {
                                    console.log('aaaaaaaaaaaaaaaa3',section)
                                    return (
                                        <div className="w-100 mb-4" key={index}>
                                            <div className="px-3 py-2" style={{ border: '1px solid #eee', borderBottom: 'none', backgroundColor: '#f2f6f8', borderRadius: '8px 8px 0px 0px' }}>
                                                <p className="text-semibig text-capitalize text-bold">{checkTranslation(section.title)}</p>
                                            </div>
                                            <div className="w-100" style={{ overflow: 'auto' }}>
                                                <table className="w-100 permissions-table ">
                                                    <thead>
                                                        <tr>
                                                            <td style={{ minWidth: 150, width: '30%' }}></td>
                                                            <td className="text-uppercase text-smaller text-bold" style={{ color: '#789' }}>{translate("Full Access")}</td>

                                                            {Object.values(section.headers).map((header, hindex) => {
                                                                // console.log(header)
                                                                if (header.main) {
                                                                    return (
                                                                        <td key={hindex}>
                                                                            <p className="text-uppercase text-smaller text-bold " style={{ color: '#789' }}>{checkTranslation(header.title)}</p>
                                                                        </td>
                                                                    )
                                                                }
                                                            })}
                                                            {section.hasExtraHeaders && (
                                                                <td></td>
                                                            )}


                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        {Object.values(section.permissions).map((permission, pindex) => {
                                                            return (
                                                                <tr key={pindex}>
                                                                    <td className="text-capitalize text-small">{checkTranslation(permission.title)}</td>
                                                                    <td className="text-center cursor-pointer" onClick={() => this.fullAccessedClicked(section, permission)} >
                                                                        {/* {console.log(section.key + '.' + permission.key)} */}
                                                                        {/* <input type="checkbox" onClick={() => this.fullAccessedClicked(section, permission)} checked={this.getFullAccessPermission(section.key + '.' + permission.key)} /> */}
                                                                        <input type="checkbox" ref={elem => elem && (elem.indeterminate = (this.getFullAccessPermission(section.key + '.' + permission.key) == '-'))} checked={this.getFullAccessPermission(section.key + '.' + permission.key)} />

                                                                    </td>

                                                                    {Object.values(section.headers).map((header, hindex) => {
                                                                        if (header.main) {
                                                                            return (
                                                                                <td key={hindex} className={"text-center  " + (permission.headers[header.key] ? ' cursor-pointer' : '')} onClick={() => { if (permission.headers[header.key]) this.changeAccess(section, permission, permission.headers[header.key]) }}>
                                                                                    {permission.headers[header.key] && (
                                                                                        <div>
                                                                                            <input type="checkbox" indeterminate={true} checked={this.getPermission(section.key + '.' + permission.key + '.' + header.key, header.reverse)} />
                                                                                            {/* <p className="text-smaller cursor-pointer mt-1 " style={{ color: '#9ab' }}>Conditional?</p> */}

                                                                                            {/* <p className="text-smaller cursor-pointer mt-1" style={{color:'#007aff'}}>Conditional</p> */}

                                                                                            {/* <p>{checkTranslation(header.title)}</p> */}
                                                                                        </div>
                                                                                    )}
                                                                                </td>
                                                                            )
                                                                        }
                                                                    })}

                                                                    {section.hasExtraHeaders && (
                                                                        <td><p className="text-small cursor-pointer text-center" style={{ color: '#007aff' }}>{translate("More Permissions")}</p></td>
                                                                    )}

                                                                </tr>
                                                            )
                                                        })}

                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    )
                                })}





                            </div>

                        </div>


                    </div>


                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        initData={this.state.currentItem}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                    />




                    <OptionsListModal ref={el => this.optionsModal = el}
                        options={this.state.options}
                    />

                    <RemoveConfirmationModal ref={el => this.removeModal = el} confirmed={this.fetchRemove} />




                </div>

                <div className="blur-back w-100 flexc sticky-md" style={{ padding: '5px 3% 5px 3%', bottom: this.props.settings.isMobile ? 60 : 0, backgroundColor: '#ffffffaa', borderTop: '1px solid #ddd' }}>
                    <div className="row mx-0 w-100">
                        <div className="col-12 col-md-6 flexc">
                            <div className="">
                                <LoaderButton
                                    onClick={this.submitClicked}
                                    isLoading={this.state.isLoading}
                                    text={translate("Submit").toUpperCase()}
                                    type={"Oval"}
                                    className="mt-2 mb-2"
                                    buttonStyle={{ outline: 'none', background: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', cursor: 'pointer', padding: '8px 45px', borderRadius: 40, fontSize: 14, fontWeight: '500', color: '#fff', border: 'none' }}
                                    width={40}
                                    height={40}
                                    color={'#202020'}
                                />
                            </div>

                            <div className="mld-2">
                                <LoaderButton
                                    onClick={this.cancelClicked}
                                    isLoading={this.state.isLoading}
                                    text={translate("Cancel").toUpperCase()}
                                    type={"Oval"}
                                    className="mt-2 mb-2"
                                    buttonStyle={{ outline: 'none', background: 'linear-gradient(to left bottom, #e2e6e8, #e8e9f0', cursor: 'pointer', padding: '8px 45px', borderRadius: 40, fontSize: 14, fontWeight: '500', color: '#222', border: 'none' }}
                                    width={40}
                                    height={40}
                                    color={'#202020'}
                                />
                            </div>
                        </div>



                        {/* <div className="col-12 col-md-6 flexc d-none d-md-flex flexc justify-content-end">

                                            <button className="flexcc" style={{ color: '#007aff' }}>
                                                <div className="mrd-2 flexcc" style={{ height: 20, width: 20, borderRadius: 20, backgroundColor: '#007aff' }}><img className="invert" src="/images/light-bolt.svg" height="16px" /></div>
                                                Extra Actions
                                            </button>
                                        </div> */}
                    </div>


                </div>

                <SearchUsersModal ref={el => this.searchUsersModal = el} onDone={this.onNewUsersSelected} setData={this.setData} data={this.state.selectedUsers} variables={variables} currentTab={this.state.currentTab} />
                <SearchGroupsModal ref={el => this.searchGroupsModal = el} onDone={this.onNewUsersSelected} data={this.state.selectedUsers} variables={variables} />

                <AddPermissionModal
                    isLoading={this.state.isLoadingPermission}
                    onDone={this.permissionTypeSelected}
                    ref={el => this.addPermissionModal = el}
                />

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AdminPermission));
